/**
 * The discriminator of one Verlauf row: WHICH of the six reads produced it.
 *
 * <h2>Frontend-only, and deliberately not an ordinal mirror</h2>
 * Unlike {@code SmAuditEventTypeEnum} or {@code SmSignerStatusEnum}, this enum has no backend twin.
 * Nothing serialises it, nothing stores it, and no ordinal of it ever crosses the wire - it exists
 * so that {@code SmSigningProcessTimelineService} can merge six differently shaped result sets into
 * one sorted list and still let the reader tell a signature apart from an audit entry. Members may
 * therefore be reordered or removed freely; the usual append-only, the-ordinal-is-a-contract rule
 * of this folder does NOT apply here.
 *
 * <h2>What it is NOT</h2>
 * It is not a presentation key. Icon, label and colour of an audit row come from the backend
 * {@code @UiEnumValueInfo} metadata of {@code SmAuditEventTypeEnum}, served as
 * {@code MvsFormValueListEntryDto.image} / {@code .color} / {@code .backgroundColor}. Do not hang a
 * TypeScript colour or icon table off this enum - a duplicate presentation map is exactly the
 * hand-rolled construct the design forbids.
 */
export enum SmTimelineSourceEnum {

    /** `sm.SmAuditEvent` - the hash-chained backbone of the process. */
    audit,

    /** `ns.NsNotificationChannelRecipient` - what was delivered to a signer, and with what outcome. */
    notification,

    /** `sm.SmSigningProcessSignerField` joined to `sm.Signature` - one placed signature. */
    signature,

    /** `sm.SmDocumentVersion` - a document version of the process. */
    document,

    /** `cc.ObjectActionGuid` - a signing link that was issued for a signer. */
    link
}
